import React from 'react';
import clsx from 'clsx';
import LoadingSpinner from './LoadingSpinner';
import styles from './LoadingState.module.css';

export interface LoadingStateProps {
  message?: string;
  showSpinner?: boolean;
  spinnerSize?: 'small' | 'medium' | 'large';
  className?: string;
  dataTestId?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message,
  showSpinner = true,
  spinnerSize = 'large',
  className,
  dataTestId
}) => {
  return (
    <output
      className={clsx(styles.loadingState, className)}
      data-test-id={dataTestId}
      aria-label={message || 'Loading'}
    >
      <div className={styles.spinnerContainer}>
        {showSpinner && <LoadingSpinner size={spinnerSize} />}
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </output>
  );
};

export default LoadingState;
